import React from 'react';
import { getTypeformUrl } from '../utils/cookies';
export const ClosingCTA = () => {
  const handleScheduleCall = (e: React.MouseEvent) => {
    e.preventDefault();
    window.location.href = getTypeformUrl();
  };
  return <section className="bg-[#1a2e1c] py-20 md:py-28 relative overflow-hidden" data-id="element-124">
      {/* Background accents */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-[#d8a34d] opacity-[0.06] rounded-full blur-3xl pointer-events-none -translate-y-1/2" data-id="element-125"></div>
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-[#d8a34d] opacity-[0.04] rounded-full blur-3xl pointer-events-none translate-x-1/3 translate-y-1/3" data-id="element-126"></div>

      <div className="container mx-auto px-4 md:px-8 relative z-10" data-id="element-127">
        <div className="max-w-3xl mx-auto text-center" data-id="element-128">
          {/* Eyebrow */}
          <span className="text-[#d8a34d] text-xs md:text-sm font-semibold tracking-[0.2em] uppercase mb-5 block" data-id="element-129">
            Start Your Investment Journey
          </span>

          {/* Heading */}
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-bold text-white leading-tight mb-6" data-id="element-130">
            Ready to Invest in Dubai Real Estate?
          </h2>

          {/* Description */}
          <p className="text-white/60 text-base md:text-lg leading-relaxed mb-10 max-w-xl mx-auto" data-id="element-131">
            Speak with a Dubai investment advisor and get a personalized
            portfolio recommendation — or download our free guide to get
            started.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-132">
            <a href="#" onClick={handleScheduleCall} className="btn-gold px-8 py-4 md:px-10 md:py-5 rounded-lg font-bold text-base md:text-lg shadow-[0_0_30px_rgba(216,163,77,0.2)] w-full sm:w-auto text-center" data-id="element-133">
              Book a Free Strategy Call
            </a>
            <a href="#guide" onClick={e => {
            e.preventDefault();
            document.querySelector('#guide')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} className="px-8 py-4 md:px-10 md:py-5 rounded-lg font-bold text-base md:text-lg border border-white/20 text-white hover:bg-white/5 transition-colors w-full sm:w-auto text-center" data-id="element-134">
              Download Free Guide
            </a>
          </div>
        </div>
      </div>
    </section>;
};